// class for RfxResponse


import { DateTime } from 'luxon';
import { MessageThreadReadStatus } from './messageThreads';

// make other classes for related/nested things!

class RfxResponse {
    constructor({  // you can set defaults for constructor params here, or just let them be undefined and set in constructor method
        id,
        pk,  // for old times sake
        created,
        modified,
        tenant_id,
        vendor_id,
        vendor,
        rfx_id,
        rfx,  // try NOT to nest it here... return in parallel if possible, but including it here to support previous style for some components/endpoints
        invitation_note,
        invitation_date,
        invited_by_id,
        invited_by,
        invited_tus,  // don't get invited_tus in constructor -- it also requires a query, so just get nested array or none -- if need IDs can get with a getter
        allow_anytime_submit,
        source,
        source_display,
        // overall_score,  // save score stuff for later
        // overall_score_max,
        // meets_requirements,
        //status_lookup,
        sm_state,
        last_sm_state,
        state_dict,
        is_submitted,
        possible_transitions,
        // possible_states,  // can get this from possible_transitions?
        was_viewed,
        is_starred,
        is_flagged_for_vendor,
        // submitted_on,  // removing?  refer to Submission model
        last_submitted_on,
        submitted_by_id,
        submitted_by,  // removing?  refer to Submission model
        external_message_thread_id,
        external_message_thread,
        external_thread_tu_read_status,  // or can we calculate locally? get last read status instead, then we can update more easily?
        internal_message_thread_id,
        internal_message_thread,
        internal_thread_tu_read_status,  // or can we calculate locally?
        manage_response_url,
        manage_response_url_full,
        vendor_url,
        vendor_url_full,
        vendor_messages_url,
        can_vendor_view,  
        can_vendor_modify,  // you also have field ._can_vendor_modify - but this gets from model method, which is right
        can_vendor_new_submit,
        rtu_role,  // role name (string) of the RfxTenantUser of current TU - 'admin', 'decision', etc.
        needs_attention_external,  // boolean, flag saying if attention needed based on todo validation, etc.
        needs_attention_external_text,  // explanation of what needs attention - string
        rfx_award_notices,  // ARRAY of nested RfxAwardNotice objects, if any
    }) {
        // make sure to set defaults if they won't always be there, and undefined isn't cool!
        this.id = id ?? pk;
        this.pk = pk ?? id;
        this.created = created ? DateTime.fromISO(created) : null;
        this.modified = modified ? DateTime.fromISO(modified) : null;
        this.tenant_id = tenant_id ?? '';
        this.vendor_id = vendor_id ?? '';
        this.vendor = vendor ?? {};
        this.vendor_name = this.vendor.name ?? '';  // bring to top level for easy handling
        this.rfx_id = rfx_id ?? '';
        this.rfx = rfx ?? {};  // just putting it here to support old style of doing it, but ideally you should use other class that holds both Response and RFX in parallel
        this.rfx_title = this.rfx?.title ?? '';  // so I can support old style components where we only needed RFX title
        this.invitation_note = invitation_note ?? '';
        this.invitation_date = invitation_date ? DateTime.fromISO(invitation_date) : null;
        this.invited_by_id = invited_by_id ?? '';
        this.invited_by = invited_by ?? {};
        this.invited_tus = invited_tus ?? [];
        this.allow_anytime_submit = allow_anytime_submit;  // leave booleans as is
        this.source = source ?? '';
        this.source_display = source_display ?? '';
        //this.status_lookup = status_lookup ?? '';
        this.sm_state = sm_state ?? '';
        this.last_sm_state = last_sm_state ?? '';
        this.state_dict = state_dict ?? {};
        this.response_list_order = this.state_dict.response_list_order ?? 0;  // a NUMBER for ordering the responses in a list, pulled out to make it top level for convenience
        this.is_submitted = is_submitted;  // leave booleans as is
        this.possible_transitions = possible_transitions ?? [];
        this.was_viewed = was_viewed;  // leave booleans as is
        this.is_starred = is_starred;  // leave booleans as is
        this.is_flagged_for_vendor = is_flagged_for_vendor;
        this.last_submitted_on = last_submitted_on ? DateTime.fromISO(last_submitted_on) : null;
        this.submitted_by_id = submitted_by_id ?? '';
        this.submitted_by = submitted_by ?? {};
        this.external_message_thread_id = external_message_thread_id ?? '';
        this.external_message_thread = external_message_thread ?? {};
        this.internal_message_thread_id = internal_message_thread_id ?? '';
        this.internal_message_thread = internal_message_thread ?? {};
        this.external_thread_tu_read_status = external_thread_tu_read_status ? new MessageThreadReadStatus(external_thread_tu_read_status) : {};  // will be an object if TU is a member of the thread, or None/null if not
        this.internal_thread_tu_read_status = internal_thread_tu_read_status ? new MessageThreadReadStatus(internal_thread_tu_read_status) : {};  // will be an object if TU is a member of the thread, or None/null if not
        this.manage_response_url = manage_response_url ?? '';
        this.manage_response_url_full = manage_response_url_full ?? '';
        this.vendor_url = vendor_url ?? '';
        this.vendor_url_full = vendor_url_full ?? '';
        this.vendor_messages_url = vendor_messages_url ?? '';
        this.can_vendor_view = can_vendor_view;  // leave booleans as is
        this.can_vendor_modify = can_vendor_modify;  // leave booleans as is
        this.can_vendor_new_submit = can_vendor_new_submit;  // leave booleans as is
        this.rtu_role = rtu_role ?? '';
        this.needs_attention_external = needs_attention_external;  // leave booleans as is
        this.needs_attention_external_text = needs_attention_external_text ?? '';
        this.rfx_award_notices = rfx_award_notices ?? [];
        // new things - frontend router links, etc.?
        //this.profileRouterLink = this.makeProfileRouterLink();  // string or object
        //this.manageRouterLink = this.makeManageRouterLink();  // string or object
        //this.adminRouterLink = this.makeAdminRouterLink();
    }
    // GETTERS
    // getters don't work in Vue as you expect.... don't use them
    // METHODS
    // TO ADD
    //is_submitted() {}
    //is_invite() {}
    //can_receive_reminder() {}
    //can_receive_invite() {}
    //admin_tu_ids() {}  // get things from RFX / team, etc.
}


export {
    RfxResponse,
}